module.exports = __webpack_public_path__ + "4ecafbbc3e0527cb262735650082033f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/studio3.jpg
// module id = 528
// module chunks = 0